import React, { useMemo } from 'react'
// eslint-disable-next-line no-unused-vars
import { Typography, ListItem, ListItemIcon, ListItemText, Grid, makeStyles, Button, Card, CardContent, List } from '@material-ui/core'
import { Link } from 'react-router-dom'
import {
    faHome, faEnvelope, faArrowCircleLeft,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import View from '../View'
import ghost from 'images/characters/pixel_ghost180.png'

const useStyles = makeStyles(theme => ({
    root: {
    },
    skySize: {
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingTop: '2rem',
        paddingBottom: '1rem',
    },
}))

const ListItemLink = ({ to, primary, icon }: { to: string, primary: string, icon?: React.ReactNode }) => {
    const renderLink = useMemo(
        // @ts-ignore
        () => React.forwardRef(function intoLink(itemProps, ref){ return <Link to={to} ref={ref} {...itemProps} /> }),
        [to]
    )
    return (
        <li>
            <ListItem button component={renderLink}>
                {icon && (
                    <ListItemIcon>{icon}</ListItemIcon>
                )}
                <ListItemText primary={primary} />
            </ListItem>
        </li>
    )
}

const NotFound = () => {
    const P = ({ children }: { children: React.ReactNode }) => (
        <Typography variant='body1'>
            {children}
        </Typography>
    )
    const history = useHistory()
    const classes = useStyles()
    return (
        <View title='Not Found - 404' header=''>
            <Grid container direction='row' justifyContent='center' alignItems='center'>
                <Grid item xs={11} md={10} className={classes.skySize} alignItems='center'>
                    <Card>
                        <CardContent>
                            <Typography variant="h1" color='error'>Content Not Found - 404</Typography>
                            <div><img src={ghost} alt=''/></div>
                            <P>The content you were looking for wasn&apos;t found.</P>
                            <P>Try to:</P>
                            <List aria-label="main">
                                {history && history.goBack && (
                                    <ListItem><Button onClick={history?.goBack} variant='contained'> <Icon icon={faArrowCircleLeft} />&nbsp;Go Back</Button></ListItem>
                                )}
                                <ListItemLink to='/' icon={<Icon icon={faHome} />} primary={'Go Home'} />
                                <ListItemLink to='/contact' icon={<Icon icon={faEnvelope} />} primary={'Contact Us'} />
                            </List>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </View >
    )
}

export default NotFound
